import { createFileRoute, notFound } from "@tanstack/react-router";
import { BlogArticle } from "@/components/blog/BlogArticle";
import { getPostBySlug, SITE_URL } from "@/lib/blog";

export const Route = createFileRoute("/blog/$slug")({
  loader: ({ params }) => {
    const post = getPostBySlug(params.slug);
    if (!post) throw notFound();
    return post;
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const post = loaderData;
    const url = `${SITE_URL}/blog/${post.slug}`;
    const title = post.metaTitle ?? `${post.title} | Carolina Mountain Stamps`;
    return {
      meta: [
        { title },
        { name: "description", content: post.metaDescription },
        { property: "og:title", content: title },
        { property: "og:description", content: post.metaDescription },
        { property: "og:url", content: url },
        { property: "og:image", content: post.ogImage },
        { property: "og:type", content: "article" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: post.metaDescription },
        { name: "twitter:image", content: post.ogImage },
        { name: "article:published_time", content: post.date },
      ],
      links: [
        { rel: "canonical", href: url },
        {
          rel: "preload",
          as: "image",
          type: "image/avif",
          href: post.lcpHref,
          imageSrcSet: post.featuredPicture.avifSrcSet,
          imageSizes: post.featuredPicture.sizes,
          fetchPriority: "high",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            headline: post.title,
            description: post.metaDescription,
            image: post.ogImage,
            datePublished: post.date,
            dateModified: post.date,
            author: {
              "@type": "Organization",
              name: "Carolina Mountain Stamps",
            },
            publisher: {
              "@type": "Organization",
              name: "Carolina Mountain Stamps",
              address: {
                "@type": "PostalAddress",
                addressLocality: "Hendersonville",
                addressRegion: "NC",
                addressCountry: "US",
              },
            },
            mainEntityOfPage: url,
          }),
        },
      ],
    };
  },
  component: BlogPostPage,
});

function BlogPostPage() {
  const post = Route.useLoaderData();
  return <BlogArticle post={post} />;
}
